export enum NonAuthRoutes {
  home = '/',
  dashboard = '/dashboard',
  reports = '/reports',
  invoicesList = '/invoicesList',
  widgetConfiguration = '/widgetConfiguration',
  templateConfiguration = '/templateConfiguration',
  balance = '/balance',
  buyAndSell = '/buyandsell',
  nomination = '/nomination',
  capacity = '/capacity',
  capacityAdd = '/capacity/add',
  capacityEdit = '/capacity/edit',
  capacityEditBundle = '/capacity/edit/bundle',
  capacityEditFormalized = '/capacity/edit/formalized',
  allocations = '/allocations',
  allocationsEdit = '/allocations/edit',
  invoices = '/invoices',
  invoicesEdit = '/invoices/edit',
  customers = '/customers',
  customersAdd = '/customers/new',
  customersEdit = '/customers/edit',
  ships = '/ships',
  shipsAdd = '/ships/add',
  shipsEdit = '/ships/edit',
  comunicationCenter = '/comunicationCenter',
  trades = '/trades',
  tradesAdd = '/trades/add',
  tradesEdit = '/trades/edit',
  regulatoryReports = '/regulatoryReports',
  demandForecasting = '/demandforecasting',
  demandForecastingLP = '/demandforecastingLP',
  demandForecastingCP = '/demandforecastingCP',
  pricing = '/pricing',
  pricingAdd = '/pricing/add',
  pricingEdit = '/pricing/edit',
  priceComponentTypeAdd = '/pricing/priceComponentType/add',
  priceComponentTypeInstances = '/pricing/priceComponentType/instances',
  versions = '/pricing/versions',
  flexibility = '/flexibility',
  flexibilityAdd = '/flexibility/add',
  flexibilityEdit = '/flexibility/edit',
  invoiceCycles = '/invoiceCycles',
  invoiceCyclesNew = '/invoiceCyclesNew',
  invoiceCycleProcessing = '/invoiceCycles/processing',
  invoiceCycleFinished = '/invoiceCycles/finished',
  invoiceCycleReport = '/invoiceCycles/report',
  tanks = '/tanks',
  tanksAdd = '/tanks/add',
  tanksEdit = '/tanks/edit',
  floatingConcepts = '/floatingConcepts',
  floatingConceptsAdd = '/floatingConcepts/add',
  virtualBatteryDetail = '/floatingConcepts/virtualBatteryDetail',
  clients = '/clients',
  clientsMod = '/clientsMod',
  clientsModManagement = '/clientsMod/gestion',
  clientsModAdd = '/clientsMod/add',
  clientsModEdit = '/clientsMod/edit',
  ProductData = '/productData',
  ProductDataCommercial = '/productDataCommercial',
  Concept = '/concept',
  ConceptCommercial = '/conceptCommercial',
  Cups = '/cups',
  CupsDetails = '/cups/details',
  MeterAdd = '/cups/meter/add',
  Wholesaler = '/wholesaler',
  partners = '/partners',
  partnersEdit = '/partners/edit',
  ProductMay = '/productMay',
  Trader = '/trader',
  Consultation = '/consultation',
  Commercial = '/commercial',
  CommercialsProductData = '/commercial/productData',
  CommercialsConcept = '/commercial/concept',
  CommercialEdit = '/commercial/edit',
  CommercialsDetails = '/commercials/details',
  Guarantee = '/guarantees',
  ConsultationInformation = '/information',
  DemandLoad = '/demand',
  ContractsLoad = '/contracts',
  UnbalancedGuarantees = '/unbalancedGuarantees',
  AtrDistribution = '/atrDistribution',
  Cisternas = '/tanks',
  InfoTso = '/TSO/Informacion/Consulta',
  TemplateSettings = '/templateSettings',
  TemplateSettingsEdit = '/templateSettings/edit',
  TemplateSettingsAdd = '/templateSettings/add',
  MassiveProcess = '/massiveProcess',
  InvoicesPage = '/invoices',
  InvoicesEdit = '/invoices/edit',
  ManualInvoice = '/manualInvoice',
  ClientSearch = '/client/search',
  ClientFile = '/client/file',
  ClientAdd = '/client/add',
  ClientEdit = '/client/edit',
  ContractAdd = '/contract/add',
  ContractEdit = '/contract/edit',
  ContractDetails = '/contract/details',
  ContractQuantities = '/contract/quantities',
  ContractFlexibilities = '/contract/flexibilities',
  ContractPriceComponents = '/contract/priceComponents',
  ContractChangeOwner = '/contract/changeOwner',
  ContractCapacities = '/contract/capacities',
  ContractOrders = '/contract/orders',
  ContactInfo = '/client/contactsInfo',
  AddressInfo = '/client/addressInfo',
  Client = '/client',
  ProceduresAdd = '/procedures/add',
  GeneratorTest = '/generatorTest',
  SettlementGroups = '/settlementGroups',
  SettlementGroupFlexibilities = '/settlementGroups/flexibilities',
  SettlementGroupContracts = '/settlementGroups/contracts',
  SettlementGroupSubjects = '/settlementGroups/subjects',
  SettlementGroupChild = '/settlementGroups/childSettlementGroups',
  SettlementGroupAggregatedAdd = '/settlementGroups/aggregatedAdd',
  SettlementGroupAggregatedEdit = '/settlementGroups/aggregatedEdit',
  PriceComponents = '/priceComponents',
  PriceComponentsAdd = '/priceComponents/add',
  Products = '/products',
  ProductsAdd = '/products/add',
  ProductsEdit = '/products/edit',
  ProductsPrice = '/products/priceComponent',
  ProductsCustomize = '/products/customize',
  Documents = '/documents',
  Concepts = '/concepts',
  ConceptsAdd = '/concepts/add',
  ConceptsEdit = '/concepts/edit',
  ConceptsModifiedAdd = '/concepts/modified/add',
  ConceptsModifiedEdit = '/concepts/modified/edit',
  Leads = '/leads',
  LeadsAdd = '/leads/add',
  LeadsEdit = '/leads/edit',
  LeadsFile = '/leads/file',
  LeadsProfileDetail = '/leads/profile/detail',
  LeadsConsumptionProfile = '/leads/consumption/profile',
  LeadsReport = '/leads/report',
  Quotes = '/quotes',
  QuotesProducts = '/quotes/products',
  Tasks = '/tasks',
  TasksEdit = '/tasks/edit',
  TasksAdd = '/tasks/add',
  Profiles = '/profiles',
  ProfilesEdit = '/profiles/edit',
  Settlements = '/invoiceCycles/settlements',
  SettlementsInvoices = '/invoiceCycles/settlements/invoices',
  SettlementsAnnulation = '/invoiceCycles/settlements/annulation',
  Atlas = '/atlas',
  AtlasDocuments = '/atlas/documents',
  AccessAtlas = '/atlas/access',
  AtlasBlog = '/atlas/blog',
  AtlasBlogAdd = '/atlas/blog/new',
  AtlasBlogEdit = '/atlas/blog/:id'
}
